import {
  BenchmarkReport,
  UserRoleInReport,
} from 'spw-redux/modules/benchmark-reports/types';
import { ProjectSlimForList } from 'spw-redux/modules/projects/types';
import { IUser } from 'spw-redux/modules/user/types';
import { isTeamAdmin } from 'spw-shared/utils';

export enum UserProjectAction {
  transfer = 'Transfer',
  remove = 'Remove',
  leave = 'Leave',
  reassign = 'Reassign',
}

export const getActionForUserProject = (
  selectedUser: IUser,
  currentUser: IUser,
  project: ProjectSlimForList
) => {
  if (currentUser.id === selectedUser.id) {
    if (project.projectOwner.id === selectedUser.id)
      return UserProjectAction.transfer;
    return UserProjectAction.leave;
  }
  if (currentUser.isOrgAdmin || isTeamAdmin(currentUser)) {
    if (project.projectOwner.id === selectedUser.id)
      return UserProjectAction.reassign;
    return UserProjectAction.remove;
  }
  return null;
};

export enum UserReportAction {
  transfer = 'Transfer',
  remove = 'Remove',
  leave = 'Leave',
}

export const getActionForReportUser = (
  selectedUser: IUser,
  currentUser: IUser,
  report: BenchmarkReport
) => {
  const selectedUserIsOwner = report.owner?.id === selectedUser?.id;
  const currentUserIsReportAdmin = [
    UserRoleInReport.orgAdmin,
    UserRoleInReport.owner,
  ].includes(report.currentUserRole);
  if (selectedUserIsOwner && currentUserIsReportAdmin)
    return UserReportAction.transfer;
  const userIsViewingOwnProfile = selectedUser.id === currentUser.id;
  if (userIsViewingOwnProfile) return UserReportAction.leave;
  if (currentUserIsReportAdmin) return UserReportAction.remove;
  return null;
};
